import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { mainNavigationStyles as styles } from "@tggstore/Overrides/Widgets/Header/MainNavigation";
import { colorStrings } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.menuHeight = 57;

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        padding: 0;
    `,
};

styles.mobileSearchButton = {
    ...styles.mobileSearchButton,
    css: css`
        ${styles.mobileSearchButton?.css}
        background-color: ${getColor(colorStrings.primaryMain)};
        border: 0;
    `,
};

styles.itemWrapper = {
    ...styles.itemWrapper,
    css: css`
        ${styles.itemWrapper?.css}

        &:hover {
            color: ${getColor(colorStrings.commonGlobalWhite)};
        }
    `,
};

styles.menuItem = {
    ...styles.menuItem,
    css: css`
        ${styles.menuItem?.css}

        &&&& ${TypographyStyle} {
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 140%; /* 25.2px */

            &:hover,
            :focus {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        }
    `,
};

styles.cascadingMenu = {
    ...styles.cascadingMenu,
    cssOverrides: {
        menuItem: css`
            &:hover {
                color: ${getColor(colorStrings.commonGlobalWhite)};

                a:hover {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                    background-color: ${getColor(colorStrings.primaryMain)};

                    svg {
                        color: ${getColor(colorStrings.commonGlobalWhite)};
                    }
                }
            }
        `,
    },
    menuItemClickableProps: {
        ...styles.cascadingMenu?.menuItemClickableProps,
        css: css`
            background-color: ${getColor(colorStrings.commonGlobalWhite)};
        `,
    },

    menuItemTypographyProps: {
        ...styles.cascadingMenu?.menuItemTypographyProps,
        size: 18,
        color: colorStrings.primaryMain,
        weight: 600,
        css: css`
            &:hover {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        `,
    },
};
